import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import Chart from "chart.js/auto";

const EnergyReportingBarChart = ({ data, labels }) => {
  const chartRef = useRef(null);

  const chartData = {
    labels,
    datasets: data,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
      },
      title: {
        display: false, // Chart का नाम/टाइटल बिल्कुल नहीं दिखेगा[web:46]
      },
    },
    scales: {
      y: { beginAtZero: true }
    }
  };

  return (
    <div>
      <Bar
        ref={(chart) => (chartRef.current = chart ? chart.chartInstance : null)}
        data={chartData}
        options={options}
      />
    </div>
  );
};

export default EnergyReportingBarChart;

